var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"footer"},[_c('ul',{staticClass:"footer-links"},[_c('li',{staticClass:"cursor-pointer",on:{"click":_vm.goToImpressum}},[_vm._v("Impressum")]),_c('li',{staticClass:"cursor-pointer",on:{"click":_vm.goToDatenschutz}},[_vm._v("Datenschutz")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }